import { createContext, useContext, useEffect, useState } from "react";
import { API } from "@/lib/api";
import { SETTINGS } from "@/data/settings";

const FALLBACK = SETTINGS;

const SiteContext = createContext(FALLBACK);

export function SiteProvider({ children }) {
  const [site, setSite] = useState(FALLBACK);

  useEffect(() => {
    API.get("/settings")
      .then((res) => {
        if (res?.data && typeof res.data === "object" && !Array.isArray(res.data)) {
          setSite({ ...FALLBACK, ...res.data });
        }
      })
      .catch(() => {});
  }, []);

  const value = {
    ...site,
    waLink: `https://wa.me/${site.whatsapp_number}?text=${encodeURIComponent(site.whatsapp_message || "")}`,
    telLink: `tel:${site.phone_raw}`,
    mailLink: `mailto:${site.email}`,
  };

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
